export default "__VITE_ASSET__BG67nTom__"